/*
 * Generated by graphql-codegen. Do not modify this file manually.
 */

// @ts-ignore Allow unused imports
import type * as Types from '../../graphql/schema';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type UserLevelSettingsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type UserLevelSettingsQuery = { __typename: 'Query', userLevelSettings: { __typename: 'UserLevelSettings', securityLending: { __typename: 'SecuritiesLending', status: Types.SecuritiesLendingStatus } } };


export const UserLevelSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserLevelSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userLevelSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"securityLending"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<UserLevelSettingsQuery, UserLevelSettingsQueryVariables>;